// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Jtl-YIEjZJXfLRkcWYgbp","barLeft":"_2-x7EcmvM6kTjDnSDJ-zKE","iconTop":"_3AYCNW__b45Tf28ujniuCa","textV":"_3c2YKZltBHyVoo5tNi-KmT","actionIcon":"_2fqXws4ES7uacqs_QV9OIq","content":"_280R9yAgneB-JuRbxPGyyf","date":"m8jZ5m0aaGn4htBcBqB7Z","title":"sSb_jVsLfztA29xjooNUo","location":"_2TocgDtqf7d0k7l7oF4knW","city":"_3L-H1oBNkiPU4CdK2ctp_5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/BoxEvent/style.css
// module id = 248
// module chunks = 42